import { Content } from "@/ui";
import { createTitle } from "@/functions/createTitle";
import { consultant_helper } from "@/helpers/consultant_helper";
import { jobs_helper } from "@/helpers/jobs_helper";

export default function MeetTheTeamPage({ content }) {
  return (
    <>
      <Content items={content} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const consultant = consultant_helper.find(url_slug);

  const jobs_related_to_consultant = jobs_helper.fetch({ consultant: consultant.name });

  return {
    props: {
      meta: {
        title: createTitle(consultant.name),
      },
      content: [
        {
          id: "Header",
          component: "Header",
          props: {
            className: "bg-primary text-white",
            title: consultant.name,
            back: {
              path: `page.meet-the-team.new-zealand.consultant.component.Header.back`,
              placeholder: `Back to Meet the Team`,
              href: "/about-us/meet-our-team/new-zealand-bios/",
            },
          },
        },
        {
          id: "TeamBio",
          component: "TeamBio",
          props: {
            role: consultant["position"] ?? "",
            email: consultant["email"] ?? "",
            linkedIn: consultant["linkedin_url"] ?? "",
            phone: consultant["phone_number"] ?? "",
            photo: consultant["image"] ?? "",
            description: consultant["about"] ?? "",
            reverse: true,
          },
        },
        {
          id: "ConsultantJobs",
          component: "ConsultantJobs",
          props: {
            consultant: consultant,
            items: jobs_related_to_consultant,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  const consultants = consultant_helper.fetch({ filter: (i) => i.country_page == "New Zealand" });

  return {
    paths: consultants.map((consultant) => ({ params: { url_slug: consultant.url_slug } })),
    fallback: false,
  };
}
